import update from 'immutability-helper';

export const texturas = (state = {
    "options"  : false,
    "selected" : false
}, action) => {
    switch (action.type) {
		case "MERGE-TEXTURAS-STATES":
			state = update(state, {$merge: action.payload});
		break;

        default:
            return state;
    }

    return state
};